import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';

import { invalidateContextDependentQueries } from '@/lib/invalidate-context-dependent-queries';

export function useInvalidateContextDependentQueries(): () => void {
  const queryClient = useQueryClient();

  return useCallback(() => {
    invalidateContextDependentQueries(queryClient);
  }, [queryClient]);
}
